import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { Grid } from "@mui/material";
import appliImg from "../../../assets/Images/appliImg.jpg";
import { useNavigate } from "react-router-dom";

function ApplicationDevelopement() {
  const navigate = useNavigate();

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Application Developement</h1>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
              <div className="visitorListNewOut">
                <div className="visitorHead">All Application</div>
                <div className="applicationListNewInner">
                  <div className="apliSecDivOut">
                    <div
                      className="apliSecDiv"
                      onClick={() => navigate("/GuardApplication")}
                    >
                      <img src={appliImg} alt="altimg"/>
                    </div>
                    <h4>Guard Application</h4>
                  </div>

                  <div className="apliSecDivOut">
                    <div className="apliSecDiv" onClick={() => navigate("")}>
                      <img src={appliImg} alt="altimg"/>
                    </div>
                    <h4>Apartment Owner</h4>
                  </div>

                  <div className="apliSecDivOut">
                    <div className="apliSecDiv" onClick={() => navigate("")}>
                      <img src={appliImg} alt="altimg"/>
                    </div>
                    <h4>Apartment Tenent</h4>
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default ApplicationDevelopement;
